import { SingleRadioItemModel } from '@ui-components';

/** Odległość ustawiana, gdy użytkownik nigdy nie wybrał własnej - "Okolice". */
export const defaultDistanceMeters: number = 25000;

/** Świadomy wybór "Bez limitu" - w filtrach reprezentowany przez brak wartości. */
export const noDistanceLimit: number = 0;

export const availableFilterDistanceConst: SingleRadioItemModel<number>[] = [
  {
    name: 'Najbliżej (2 km)',
    value: 2000
  },
  {
    name: 'W pobliżu (5 km)',
    value: 5000
  },
  {
    name: 'Okolice (25 km)',
    value: defaultDistanceMeters,
    description: 'domyślne'
  },
  {
    name: 'Daleko (50 km)',
    value: 50000
  },
  {
    name: 'Bez limitu',
    value: noDistanceLimit
  }
];

export const distanceShortNameMap: Record<number, string> = {
  2000: 'Najbliżej',
  5000: 'W pobliżu',
  25000: 'Okolice',
  50000: 'Daleko'
};
